import React, { useState } from 'react'
import {
  Collapse,
  Nav,
  NavItem,
  NavbarToggler
} from 'reactstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ActionCableMounter from '../../ActionCable/Mounter'
import UserDropdownMenu from './UserDropdownMenu'

const navItems = [
  { path: '/', key: 'projects', match: (p) => p === '/' || p.startsWith('/projects') },
  { path: '/settings', key: 'settings', match: (p) => p.startsWith('/settings') },
  { path: '/users', key: 'users', match: (p) => p.startsWith('/users') },
  { path: '/locales', key: 'locales', match: (p) => p.startsWith('/locales') }
]

const ConnectedUserNavbar = () => {
  const { t } = useTranslation('ApplicationLayout')
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const location = useLocation()

  const activeIndex = navItems.findIndex((item) => item.match(location.pathname))

  return (
    <>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav
          className="d-flex flex-fill me-auto justify-content-between align-items-center"
          navbar
        >
          <div
            className="nav-items-container d-flex align-items-center"
            style={{ '--active-index': activeIndex }}
          >
            {navItems.map((item, index) => (
              <NavItem key={item.key}>
                <Link
                  className={`nav-link${activeIndex === index ? ' active' : ''}`}
                  to={item.path}
                >
                  {t(`AppNavbar.links.${item.key}`)}
                </Link>
              </NavItem>
            ))}
            <span className="nav-indicator" />
          </div>

          <UserDropdownMenu />
        </Nav>
      </Collapse>
      <ActionCableMounter />
    </>
  )
}

ConnectedUserNavbar.propTypes = {
}

export default ConnectedUserNavbar
